const isFeatureEnabled = (features, featureName) => {
  let isEnabled = false
  if (features) {
    features.filter((feature) => {
      if (feature.featureName.toUpperCase() === featureName.toUpperCase()) {
        isEnabled = feature.enabled
      }
      return isEnabled
    })
  }
  return isEnabled
}

export default isFeatureEnabled



// WEBPACK FOOTER //
// ./src/utils/features.js